<template>
  <section>
    <div class="progress-box">
      <div class="progress-container">
        <template v-for="(item, index) in progressConfig">
          <div
            class="progress-step"
            v-bind:class="{ active: progressPamars.step === index + 1 }"
            :key="index + 'step'"
          >
            <img
              class="progress-img"
              v-if="progressPamars.step === index + 1"
              :src="item.activeImgUrl"
            />
            <img class="progress-img" v-else :src="item.normalImgUrl" />
            <span class="progress-text">{{item.label}}</span>
          </div>
          <div
            class="progress-connect"
            :key="index + 'connect'"
            v-if="index !== progressConfig.length-1"
          >
            <span class="progress-connect-line"></span>
            <span class="progress-connect-img">
              <img src="~images/operate/order/toRight.png" alt />
            </span>
            <span class="progress-connect-line"></span>
          </div>
        </template>
      </div>
    </div>
    <SubBtnBox
      :cancelTextName="progressPamars.step <= 1 ? '取消' : '上一步'"
      :comfirmTextName="progressPamars.step >= progressConfig.length ? subBtnName : '下一步'"
      :customSubmit="true"
      :customCancel="true"
      :cancelBtnHide="cancelBtnHide"
      @cancel="toPreStep"
      @customSub="nextStep"
    />
  </section>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
export default {
  components: {
    SubBtnBox,
  },
  model: {
    prop: 'progressPamars',
    event: 'cc',
  },
  props: {
    progressConfig: {
      type: Array,
      default: () => ([]),
    },
    progressPamars: {
      type: Object,
      default: () => ({
        step: 1,
      }),
    },
    checkNextStep: {
      type: Boolean,
      default: false,
    },
    subBtnName: {
      type: String,
      default: '提交',
    },
    cancelBtnHide: {
      type: Boolean,
      default: false,
    },
  },
  // data () {
  //   return {
  //   };
  // },
  methods: {
    toPreStep () {
      if (this.progressPamars.step <= 1) {
        this.close();
      } else {
        this.progressPamars.step--;
        if (this.progressPamars.step < 0) {
          this.progressPamars.step = 1;
        }
      }
      this.$emit('preStep', this.progressPamars.step);
    },
    toNextStep () {
      if (this.progressPamars.step < this.progressConfig.length) {
        this.progressPamars.step++;
      }
    },
    nextStep () {
      if (this.checkNextStep) {
        // 手动控制下一步
        this.$emit('nextStep', this.progressPamars.step);
      } else {
        // 下一步不检测，到最后一步才抛出函数调用
        this.toNextStep();
        if (this.progressPamars.step >= this.progressConfig.length) {
          this.$emit('nextStep', this.progressPamars.step);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-box {
  background: #ffffff;
  height: 110px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .progress-container {
    display: flex;
    margin-bottom: 16px;
    .progress-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 16px -8px 0 -8px;
      &.active {
        .progress-text {
          color: #333333;
        }
      }
      .progress-img {
        width: 40px;
        height: 40px;
        margin-bottom: 4px;
      }
      .progress-text {
        font-size: 14px;
        color: #999999;
      }
      .progress-text {
        font-size: 14px;
        color: #999999;
      }
    }
    .progress-connect {
      display: flex;
      align-items: center;
      justify-content: center;
      .progress-connect-line {
        width: 90px;
        height: 4px;
        background-color: #e6f7ff;
      }
      .progress-connect-img {
        width: 16px;
        height: 16px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
